import React from 'react';
import { useTheme } from '../../theme';
import SectionLabel from '../shared/SectionLabel';

const items = [
  { k: 'WHAT_WE_STORE', t: 'What we store', body: 'Only the username, the platform, and the note left by whoever filed the tag. No emails, no passwords, no IPs, no analytics.' },
  { k: 'WHAT_WE_DONT', t: 'What we never do', body: 'We never message, email, or contact anyone on your behalf. Both sides choose to surface, or neither does. There is no "outreach" feature.' },
  { k: 'REMOVAL', t: 'Removing yourself', body: 'Click "remove" on any record. No login, no questions, no waiting period. The record is gone from the index within sixty seconds.' },
  { k: 'NO_RESALE', t: 'No scraping. No selling.', body: 'Every record was filed by a real person who claims to know you. We will never sell, syndicate, or expose the index to third parties.' },
];

export default function Privacy() {
  const { p, d, fonts } = useTheme();

  return (
    <section id="privacy-section" style={{
      padding: `${d.hero}px ${d.pad}px`, borderBottom: `1px solid ${p.border}`, background: p.bgPanel,
    }}>
      <div style={{
        maxWidth: 1180, margin: '0 auto', display: 'grid',
        gridTemplateColumns: '1fr 1.4fr', gap: 64, alignItems: 'start',
      }}>
        <div>
          <SectionLabel>§ 03 / privacy &amp; consent</SectionLabel>
          <h2 style={{
            fontFamily: fonts.serif, fontSize: 50, fontWeight: 400, letterSpacing: '-.025em',
            lineHeight: 1.05, color: p.textHi, margin: '0 0 22px',
          }}>
            A directory of lost friends.<br />
            <span style={{ fontStyle: 'italic', color: p.text }}>Not a surveillance tool.</span>
          </h2>
          <p style={{
            fontFamily: fonts.sans, fontSize: d.body, lineHeight: 1.6, color: p.text, margin: '0 0 24px',
          }}>
            A searchable index of usernames is delicate. We've designed UserTags so nobody ends up here against their will, and so leaving is always trivial.
          </p>
          <div style={{
            fontFamily: fonts.mono, fontSize: 12, color: p.accent, letterSpacing: '.08em',
            cursor: 'pointer', borderBottom: `1px solid ${p.accentDim}`, display: 'inline-block', paddingBottom: 4,
          }}>
            READ THE FULL CHARTER →
          </div>
        </div>
        <div style={{ border: `1px solid ${p.border}`, background: p.bg }}>
          {items.map((it, i) => (
            <div key={it.k} style={{
              padding: '24px 28px',
              borderBottom: i < items.length - 1 ? `1px solid ${p.border}` : 'none',
              display: 'grid', gridTemplateColumns: '160px 1fr', gap: 24,
            }}>
              <div style={{ fontFamily: fonts.mono, fontSize: 11, color: p.accent, letterSpacing: '.08em', paddingTop: 5 }}>
                {it.k}
              </div>
              <div>
                <div style={{
                  fontFamily: fonts.serif, fontSize: 20, fontWeight: 500, color: p.textHi,
                  letterSpacing: '-.005em', marginBottom: 6,
                }}>
                  {it.t}
                </div>
                <div style={{ fontFamily: fonts.sans, fontSize: 14, lineHeight: 1.55, color: p.text }}>
                  {it.body}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          section > div { grid-template-columns: 1fr !important; gap: 32px !important; }
          section > div > div:last-child > div { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
